import { ApiService } from "./api.service";

export const RegistrarLocation = (invoice) => {
  return new Promise(async resolve => {
    return ApiService.post("location", invoice)
      .then((response) => {
        resolve(response);
      })
      .catch(({ response }) => {
        resolve(response);
      });
  });
} 